import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"padding-top":"35px"} }

import { ref } from 'vue'
import { getRecordActionTemplate } from '@/api/shop'
import { useStore } from 'vuex'
import { ITemplateName } from '@/utils/interface'


export default /*#__PURE__*/_defineComponent({
  emits: ['customChange'],
  setup(__props, { emit }) {

const value = ref('')

const store = useStore()

const checkItem = (temp: ITemplateName) => {
  emit('customChange', temp)
}

const searchData = () => {
  if (value.value) {
    list.value = oldData.filter(
      (item: ITemplateName) => item.templateName.indexOf(value.value) !== -1
    )
  } else {
    list.value = JSON.parse(JSON.stringify(oldData))
  }
}

const list = ref<ITemplateName[]>([])

let oldData: ITemplateName[] = []
getRecordActionTemplate({
  page: 1,
  size: 200,
  thirdTenantId: store.getters.thirdTenantId
}).then((res: any) => {
  list.value = res.rows
  oldData = JSON.parse(JSON.stringify(res.rows))
})

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: value.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        searchData
      ],
      placeholder: "请输入模板的名称搜索"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_cell_group, { inset: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: item.templateId,
            onClick: ($event: any) => (checkItem(item)),
            title: item.templateName
          }, null, 8, ["onClick", "title"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})